/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef, useState } from 'react';

import frLocale from '@fullcalendar/core/locales/fr';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { registerLocale } from 'react-datepicker';
import { Bars } from 'react-loader-spinner';
import fr from 'date-fns/locale/fr';
import { Button, Title } from '@fnacdarty/back-office-ui';
import { useTheme, withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import {
	NotificationContainer,
	NotificationManager,
} from 'react-notifications';
import {
	FullCalendarWrapper,
	StyledCalendarHeader,
	StyledBlockModal,
} from './index.styled';
import {
	getFormatedEvents,
	deleteUnaivability,
	getCalendarEvents,
} from '../../utils/calendar';
import ActionMenu from '../CalendarActionMenu';
import CalendarAction from '../CalendarActions';
import 'react-notifications/lib/notifications.css';
import { Modal } from '../../../../layouts';
import { getStringTime, getStringDate } from '../../../../utils/date';

const Calendar = ({
	planning,
	selectedResource,
	setSelectedResource,
	selectedActivity,
	setSelectedActivity,
	setNewComment,
	newComment,
	isVersionPC,
	canEditPlanning,
}) => {
	const theme = useTheme();
	registerLocale('fr', fr);

	const calendarRef = useRef(null);
	const [selectedAction, setSelectedAction] = useState('none');
	const [showModalDelIndispo, setShowModalDelIndispo] = useState(false);
	const [titleButtonCancel] = useState('Annuler');
	const [titleButtonConfirm] = useState('Confirmer');
	const resource = selectedResource.id;
	const [isLoading, setIsLoading] = useState(false);

	const [formatedEvents, setFormatedEvents] = useState(() => {
		getFormatedEvents(planning, theme);
	});
	const [unavailability, setUnavailability] = useState(false);

	useEffect(() => {
		if (!isVersionPC()) {
			setSelectedActivity(selectedActivity, false);
		}
		if (planning?.length > 0) {
			return setFormatedEvents(getFormatedEvents(planning, theme));
		}
		return setFormatedEvents([]);
	}, [planning]);

	const refreshPlanning = async (resourceId) => {
		const res = await getCalendarEvents(resourceId);
		if (res) {
			setFormatedEvents(getFormatedEvents(res, theme));
		}
	};
	useEffect(() => {
		if (newComment != null) {
			setNewComment(null);
			refreshPlanning(resource);
		}
	}, [newComment]);

	const handleDelIndispoClick = async (response) => {
		if (response) {
			// eslint-disable-next-line react/prop-types
			const result = await deleteUnaivability(unavailability.id);

			if (result) {
				setIsLoading(true);
				const res = await getCalendarEvents(resource);
				if (res) {
					setFormatedEvents(getFormatedEvents(res, theme));
				}
				NotificationManager.success(
					"L'indisponibilite a été bien supprimée",
					'',
				);
				setUnavailability(false);
				setIsLoading(false);
			} else {
				NotificationManager.error(
					"Une erreur s'est produite lors de la suppression de l'indisponibilite",
					'',
				);
			}
			setShowModalDelIndispo(false);
		} else {
			setShowModalDelIndispo(false);
		}
	};

	const handleEventClick = (info) => {
		if (info.event.extendedProps?.activity) {
			setSelectedActivity(info.event.extendedProps.activity);
		}
		if (info.event.extendedProps?.unavailability) {
			setUnavailability(info.event.extendedProps.unavailability);
			setShowModalDelIndispo(true);
		}
	};

	const [startWeekDate, setStartWeekDate] = useState(null);
	const [endWeekDate, setEndWeekDate] = useState(null);
	const [isWeekView, setIsWeekView] = useState(false);

	function handleViewChange(args) {
		if (args.view.type === 'timeGridWeek') {
			setStartWeekDate(args.start);
			setEndWeekDate(args.end);
			setIsWeekView(true);
		} else {
			setIsWeekView(false);
			setStartWeekDate(null);
			setEndWeekDate(null);
		}
		localStorage.setItem('currentDateCalendar', args.startStr);
	}

	const [currentDateCalendar, setcurrentDateCalendar] = useState(
		() =>
			localStorage.getItem('currentDateCalendar') ||
			new Date().toISOString(),
	);

	const startDate = new Date(startWeekDate);
	const endDate = new Date(endWeekDate);
	const filteredEvents = formatedEvents?.filter((event) => {
		const eventDate = new Date(event.start);
		return (
			eventDate >= startDate &&
			eventDate <= endDate &&
			typeof event.title === 'undefined'
		);
	});

	const hasUndefinedTitle = new Array(7).fill(false);
	// loop through the filtered events and check if each event has a shift
	filteredEvents?.forEach((event) => {
		const dayIndex = new Date(event.start).getDay();
		if (event.title === undefined) {
			hasUndefinedTitle[dayIndex] = true;
		}
	});
	const handleDayCellContent = (arg) => {
		const today = new Date();
		const currentDate = arg.date;
		let cellClasses = 'fc-daygrid-day-number';
		if (
			arg.view.type === 'dayGridMonth' &&
			currentDate.toDateString() === today.toDateString()
		) {
			cellClasses += ' current-date';
		}
		return <div className={cellClasses}>{arg.dayNumberText}</div>;
	};

	const addScrollBarToCell = () => {
		const qualifiedElements = [
			...document.querySelectorAll('.fc-daygrid-day-events'),
		];
		qualifiedElements.forEach((element) => {
			if (element.childNodes.length > 5) {
				element.classList.add('addScrollBar');
			}
		});
	};

	useEffect(() => {
		addScrollBarToCell();
		const buttonNext = document.getElementsByClassName('fc-next-button');
		const buttonPrev = document.getElementsByClassName('fc-prev-button');
		const buttonToDay = document.getElementsByClassName('fc-today-button');

		buttonNext[0]?.addEventListener('click', (e) => {
			addScrollBarToCell();
		});
		buttonPrev[0]?.addEventListener('click', (e) => {
			addScrollBarToCell();
		});
		buttonToDay[0]?.addEventListener('click', (e) => {
			addScrollBarToCell();
		});
	});

	const headerToolbar = {
		left: isVersionPC() ? 'today,prev,next' : 'timeGridDay,timeGridWeek',
		center: isVersionPC() ? 'title' : 'title',
		right: isVersionPC()
			? 'timeGridDay,timeGridWeek,dayGridMonth'
			: 'prev,today,next',
	};

	const buttonText = isVersionPC()
		? { today: "Aujourd'hui", week: 'Semaine' }
		: {
				today: 'Auj.',
				week: 'Sem.',
		  };

	const weekText = isVersionPC() ? 'Sem.' : 'S';
	return (
		<>
			<NotificationContainer />
			<FullCalendarWrapper className="calendar">
				<StyledCalendarHeader className="calendar__header">
					{isVersionPC() && (
						<Title level={2} className="calendar__title">
							Planning{' '}
							{selectedResource?.code
								? selectedResource?.code
								: selectedResource?.name}
						</Title>
					)}
					<ActionMenu
						label="Actions"
						actions={[
							...(isWeekView && canEditPlanning
								? [
										{
											label: 'Gestion planning',
											value: 'editShift',
										},
								  ]
								: []),
							{
								label: 'Ajouter indisponibilité',
								value: 'addUnavailable',
							},
						]}
						setAction={setSelectedAction}
						showIcon={!isVersionPC()}
					/>
				</StyledCalendarHeader>

				<CalendarAction
					action={selectedAction}
					activity={selectedActivity}
					display={setSelectedAction}
					selectedResource={selectedResource}
					setSelectedResource={setSelectedResource}
					formatedEvents={formatedEvents}
					setFormatedEvents={setFormatedEvents}
					theme={theme}
					unavailability={unavailability}
					setUnavailability={setUnavailability}
					startWeekDate={startWeekDate}
					endWeekDate={endWeekDate}
					hasUndefinedTitle={hasUndefinedTitle}
					setNewComment={setNewComment}
					isVersionPC={isVersionPC}
				/>
				<div className="calendar__body">
					<FullCalendar
						initialView="timeGridWeek"
						locale={frLocale}
						plugins={[
							dayGridPlugin,
							interactionPlugin,
							timeGridPlugin,
							interactionPlugin,
						]}
						buttonText={buttonText}
						dateClick={() => {}}
						eventClick={handleEventClick}
						events={formatedEvents}
						headerToolbar={headerToolbar}
						customButtons={Button}
						allDaySlot={false}
						selectMirror={true}
						dayMaxEvents={true}
						slotMinTime="07:00:00"
						slotMaxTime="20:00:00"
						nowIndicator={true}
						handleWindowResize={true}
						height="auto"
						navLinks={true}
						navLinkDayClick={true}
						initialDate={currentDateCalendar} // Initialiser avec la date sauvegardée
						dayHeaderContent={(arg) => {
							const { date } = arg;
							const isTimeGridDayView =
								arg.view.type === 'timeGridDay';
							const isTimeGridWeekView =
								arg.view.type === 'timeGridWeek';
							const options = {
								weekday: isTimeGridDayView ? 'long' : 'short',
								day:
									isTimeGridDayView || isTimeGridWeekView
										? 'numeric'
										: undefined,
							};

							return date.toLocaleString('fr-FR', options);
						}}
						datesSet={handleViewChange}
						ref={calendarRef}
						weekNumbers={true}
						dayCellContent={handleDayCellContent}
						weekText={weekText}
					/>
				</div>
			</FullCalendarWrapper>
			{showModalDelIndispo && (
				<Modal
					onClickCallback={handleDelIndispoClick}
					cancelAction={isLoading ? '' : titleButtonCancel}
					confirmAction={isLoading ? '' : titleButtonConfirm}
					title={isVersionPC() ? 'Supprimer une indisponibilité' : ''}
					style={{
						position: 'fixed',
						width: isVersionPC() ? '40%' : '90%',
					}}
				>
					{unavailability && !isLoading ? (
						<StyledBlockModal>
							<span>
								Voulez-vous supprimer l&apos;indisponibilté
								du&nbsp;
								{getStringDate(unavailability.start)}
								&nbsp;de&nbsp;
								{getStringTime(unavailability.start)} à&nbsp;
								{getStringTime(unavailability.end)} ?
							</span>
						</StyledBlockModal>
					) : null}
					{isLoading ? (
						<StyledBlockModal>
							<Bars
								height="80"
								width="80"
								color="#b8cbf2"
								ariaLabel="bars-loading"
								wrapperStyle={{}}
								wrapperClass=""
								visible={true}
							/>
						</StyledBlockModal>
					) : null}
				</Modal>
			)}
		</>
	);
};

Calendar.propTypes = {
	planning: PropTypes.array,
	selectedResource: PropTypes.object,
	setSelectedResource: PropTypes.func,
	selectedActivity: PropTypes.object,
	setSelectedActivity: PropTypes.func,
	setNewComment: PropTypes.func,
	newComment: PropTypes,
	isVersionPC: PropTypes.func,
	canEditPlanning: PropTypes.bool,
};

export default withTheme(Calendar);
